import * as React from "react";

// Redecalare forwardRef, https://fettblog.eu/typescript-react-generic-forward-refs/
declare module "react" {
    function forwardRef<T, P = {}>(
        render: (props: P, ref: React.Ref<T>) => React.ReactElement | null
    ): (props: P & React.RefAttributes<T>) => React.ReactElement | null;
}

export type Nullable<T> = T | null; // TODO check usage, sometimes cypress type is used...

export type NullableFields<T> = {
    [P in keyof T]: Nullable<T[P]>;
};

export type UnknownFields<T> = {
    [P in keyof T]: unknown;
};

export type Updater<T> = (current: T) => T;

// typed object key access, e.g. you need to pass it as plain string
export const assertKey = <T extends { [key: string]: any }>(k: keyof T) => k;
